import React, { useEffect } from 'react';
import { Button, Label } from 'reactstrap';
import SingleUpload from '../../commons/Upload/SingleUpload';
import { EmptyFileManager, NoFile, SearchEmptyPage } from '../../../assets/images';
import { Loader, UploadModal } from '../../commons';
import { UploadFileTypesPayload } from '../../../commonTypes/fileManagerTypes';
import './EmptyDocumentData.scss';
import { useParams } from 'react-router-dom';

type AppProps = {
  toggleAddFolderModal: () => void;
  type?:string;
  documentList?: any;
  imageWidth?: string;
  handleUploadFile?: (data: UploadFileTypesPayload) => void;
  client_code?: number | string;
  isAddFolderPresent: boolean;
  isUploadPresent: boolean;
  // uploadFetching?: boolean;
  //  folder_id?: string|number|string;
	// token?: string|null;
  // dispatchGetChildFoldersAction?: (data: any) => void;
  // uploadSuccess: number | null;
  // dispatchResetUploadFileData?:()=>void
}

const EmptyDocumentData = ({
  toggleAddFolderModal,
  documentList,
  handleUploadFile,
  imageWidth,
  client_code,
  isAddFolderPresent,
  isUploadPresent,
  type,
  // uploadFetching,
  // folder_id,
	// token,
	// dispatchGetChildFoldersAction,
  // uploadSuccess,
  // dispatchResetUploadFileData
}: AppProps) => {

  	const urlData = useParams<{ data?:string| undefined}>();
    const searchData= urlData?.data

//   useEffect(() => {
//   dispatchResetUploadFileData&&dispatchResetUploadFileData()
// },[])

//   useEffect(() => {
//    if (client_code && token&&uploadSuccess) {
// 			let finalData = {
// 				client_code,
// 				folder_id,
// 				token
// 			}
// 		dispatchGetChildFoldersAction&&dispatchGetChildFoldersAction(finalData);
// 		}; 
//   },[uploadSuccess])

  return (
    <div style={{height:"400px"}}>
      <div className="text-center no-document-style mt-5" >
        <img src={!searchData?NoFile:SearchEmptyPage} alt="no-file" style={{width:searchData?"300px":"200px"}} className={searchData?"mb-0":"mb-5"} />
        <h1>
         {searchData?"Uh-oh! No Files/Folder Found.": "No files in this folder"}
        </h1>
        {type
        ?
        <span className="sub-text"></span>
        :
        <span className="sub-text"> {searchData?"It seems we couldn't find any results matching your search. Please try again with different keywords.":"Click on upload button to add files here."}</span>}
      </div>
      {/* <div className="text-center">
        <div className="d-flex flex-row justify-content-center mt-3 mb-4">
          {isAddFolderPresent && <div onClick={toggleAddFolderModal}>
            <Label
              className="btn btn-primary mr-3"
              style={{ cursor: "pointer" }}
            >
              + Create Folder
            </Label>
          </div>}
        </div> */}
        {/* <h5 className="mt-3 mb-3">OR</h5> */}
        {/* {isUploadPresent && <div className="w-75 m-auto">
          <UploadModal
            handleUploadFile={handleUploadFile}
            client_code={client_code}
          />
        </div>}
      </div> */}
      {/* {uploadFetching&&<Loader/>} */}
    </div>
  )
};

export default EmptyDocumentData;